<template>
  <div>
    <div class="table-example mb-6">
      <div class="header">
        <v-row>
          <v-col cols="5">
            <div class="header__item">Наименование и реквизиты документа</div>
          </v-col>
          <v-col cols="3">
            <div class="header__item">Файл</div>
          </v-col>
          <v-col cols="4">
            <div class="header__item">ЭП файла</div>
          </v-col>
        </v-row>
      </div>

      <div class="data" v-for="(document, index) in documents" :key="index">
        <v-row>
          <v-col cols="5">
            <div class="d-flex justify-space-between">
              <span class="text break-word">{{
                document.description ||
                getSubDescription({
                  name: document.name,
                  docDate: document.docDate,
                  number: document.number,
                })
              }}</span>
            </div>
          </v-col>
          <v-col cols="3">
            <div class="d-flex justify-space-between">
              <a
                class="link break-word"
                :href="getFileLink(document.file.link)"
                >{{ document.file.name }}</a
              >
            </div>
          </v-col>
          <v-col cols="4">
            <div class="d-flex justify-space-between">
              <a
                class="link break-word"
                :href="getFileLink(document.fileSig.link)"
              >
                {{ document.fileSig.name }}
              </a>
              <v-btn
                v-if="!document.preventDelete && showDeleteBtn"
                depressed
                color="transparent"
                class="ml-2"
                x-small
                fab
                @click="remove(document.fileSig.link)"
                :loading="loadingRemove"
              >
                <v-icon color="red">{{ mdiTrashCanOutline }}</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="documents.length === 0" class="no-value">Нет документов</div>
    </div>

    <v-btn
      @click="dialog = true"
      depressed
      color="primary"
      class="button-base"
      v-if="showAddDocumentBtn"
    >
      Добавить документ
    </v-btn>
    <div class="ud-error">
      <div class="ud-error__wrapper">
        <div
          class="ud-error__text"
          v-for="(error, index) in errorMessages"
          :key="index"
        >
          {{ error }}
        </div>
      </div>
    </div>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <form @submit.prevent="upload" class="form form-base">
        <div class="form-base__title mb-4">Добавление документа</div>

        <!-- Документ: start -->
        <v-row v-if="typeDocument === AdditionalDocumentsType.ADD_DOCUMENTS">
          <v-col cols="8">
            <v-text-field
              v-model.trim="$v.documentFilds.name.$model"
              :error-messages="getValidationErrorText($v.documentFilds.name)"
              label="Наименование документа"
              outlined
            />
          </v-col>
          <v-col cols="4">
            <DateFieldCustom
              label="Дата выдачи"
              :value="$v.documentFilds.date.$model"
              @change="$v.documentFilds.date.$model = $event"
              :errorMessage="$v.documentFilds.date"
              :max="new Date().toISOString()"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model.trim="$v.documentFilds.issuer.$model"
              :error-messages="getValidationErrorText($v.documentFilds.issuer)"
              label="Кем выдан"
              outlined
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="$v.documentFilds.series.$model"
              :error-messages="getValidationErrorText($v.documentFilds.series)"
              label="Серия документа"
              outlined
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="$v.documentFilds.number.$model"
              :error-messages="getValidationErrorText($v.documentFilds.number)"
              label="Номер документа"
              outlined
            />
          </v-col>
        </v-row>
        <!-- Документ: end -->

        <!-- Платежный документ: start -->
        <v-row v-if="typeDocument === AdditionalDocumentsType.ADD_QUITTANCES">
          <v-col cols="8">
            <v-text-field
              v-model.trim="$v.documentPaymentFilds.name.$model"
              :error-messages="
                getValidationErrorText($v.documentPaymentFilds.name)
              "
              label="Наименование документа"
              outlined
            />
          </v-col>
          <v-col cols="4">
            <DateFieldCustom
              label="Дата выдачи"
              :value="$v.documentPaymentFilds.date.$model"
              @change="$v.documentPaymentFilds.date.$model = $event"
              :errorMessage="$v.documentPaymentFilds.date"
              :max="new Date().toISOString()"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="$v.documentPaymentFilds.number.$model"
              :error-messages="
                getValidationErrorText($v.documentPaymentFilds.number)
              "
              label="Номер документа"
              outlined
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="$v.documentPaymentFilds.payerLastname.$model"
              :error-messages="
                getValidationErrorText($v.documentPaymentFilds.payerLastname)
              "
              label="Фамилия плательщика"
              outlined
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="$v.documentPaymentFilds.payerFirstname.$model"
              :error-messages="
                getValidationErrorText($v.documentPaymentFilds.payerFirstname)
              "
              label="Имя плательщика"
              outlined
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="$v.documentPaymentFilds.payerMiddleName.$model"
              :error-messages="
                getValidationErrorText($v.documentPaymentFilds.payerMiddleName)
              "
              label="Отчество плательщика"
              outlined
            />
          </v-col>
          <v-col cols="6">
            <CurrencyField
              v-model="$v.documentPaymentFilds.amount.$model"
              label="Сумма"
              :errorMessages="
                getValidationErrorText($v.documentPaymentFilds.amount)
              "
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="$v.documentPaymentFilds.accountNum.$model"
              :error-messages="
                getValidationErrorText($v.documentPaymentFilds.accountNum)
              "
              label="Номер счета"
              v-mask="['####################']"
              outlined
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="$v.documentPaymentFilds.accountCorrNum.$model"
              :error-messages="
                getValidationErrorText($v.documentPaymentFilds.accountCorrNum)
              "
              label="Номер корреспондентского счета"
              v-mask="['####################']"
              outlined
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="$v.documentPaymentFilds.bik.$model"
              :error-messages="
                getValidationErrorText($v.documentPaymentFilds.bik)
              "
              label="БИК"
              v-mask="['#########']"
              outlined
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model.trim="$v.documentPaymentFilds.bankName.$model"
              :error-messages="
                getValidationErrorText($v.documentPaymentFilds.bankName)
              "
              label="Наименование банка получателя"
              outlined
            />
          </v-col>
        </v-row>
        <!-- Платежный документ: end -->

        <v-row>
          <v-col cols="12">
            <v-file-input
              v-model="$v.file.$model"
              :accept="acceptFile"
              @click:clear="reset(InputType.FILE)"
              :error-messages="getValidationErrorText($v.file)"
              label="Прикладываемый документ"
              outlined
            />
          </v-col>
          <v-col>
            <v-file-input
              v-model="$v.fileSig.$model"
              accept=".sig"
              @click:clear="reset(InputType.FILE_SIG)"
              :disabled="!Boolean(file)"
              :error-messages="getValidationErrorText($v.fileSig)"
              label="Прикладываемая ЭП документа"
              outlined
            />
          </v-col>
          <v-col cols="auto">
            <v-btn
              @click="signFile"
              :disabled="Boolean(fileSig) || !Boolean(file)"
              depressed
              class="button-base-white"
              :loading="loadingSign"
            >
              Подписать
            </v-btn>
          </v-col>
        </v-row>

        <div v-if="error" class="error--text">
          {{ error }}
        </div>

        <v-row justify="end">
          <v-col cols="auto">
            <v-btn @click="dialog = false" depressed class="button-base-white">
              Отмена
            </v-btn>
          </v-col>

          <v-col cols="auto">
            <v-btn
              type="submit"
              depressed
              color="primary"
              class="button-base"
              :loading="loading"
            >
              Добавить файл в опись
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </v-dialog>
  </div>
</template>

<script>
import { mdiTrashCanOutline } from '@mdi/js';
import {
  required,
  maxLength,
  minLength,
  and,
  requiredIf,
} from 'vuelidate/lib/validators';
import cloneDeep from 'clone-deep';
import {
  FILE_NAME_MAX_LENGTH,
  FILE_SIG_NAME,
  FILE_SIZE,
  FILE_TYPE,
  DATE_FORMAT,
  DATE_FUTURE,
  DATE_PAST,
  CURRENCY_MAX_LENGTH,
  CURRENCY_ONLY_POSITIVE,
  EMOJI,
  getValidationErrorText,
  PERSON_NAME,
} from '@/utils/validate';
import {
  deleteFile,
  getFileLink,
  saveFile,
  saveSigFile,
} from '@/api/filestorage';
import { ErrorAlertModule } from '@/store/modules/errors';
import { ServicesModule } from '@/store/modules/services';
import { errorHandler, getSubDescription } from '@/utils/common';
import { AdditionalDocumentsType } from '@/types/alternativeServices';

import CurrencyField from '@/components/base/CurrencyField.vue';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import { checkSign } from '@/api/checkSign';
import deepmerge from 'deepmerge';

const InputType = {
  FILE: 'file',
  FILE_SIG: 'fileSig',
};

const documentTypeFilds = {
  [AdditionalDocumentsType.ADD_DOCUMENTS]: 'documentFilds',
  [AdditionalDocumentsType.ADD_QUITTANCES]: 'documentPaymentFilds',
};

const documentModel = {
  type: 'OTHER',
  name: '',
  date: null,
  issuer: '',
  series: '',
  number: '',
};

const documentPaymentModel = {
  type: 'QUITTANCE',
  name: '',
  date: null,
  number: '',
  payerLastname: '',
  payerFirstname: '',
  payerMiddleName: '',
  amount: null,
  accountNum: null,
  accountCorrNum: null,
  bankName: '',
  bik: null,
};

const acceptFileDefault = ['.pdf'];

export default {
  name: 'UploadDocumentAlt',
  components: {
    DateFieldCustom,
    CurrencyField,
  },
  model: {
    prop: 'documents',
    event: 'change',
  },
  props: {
    showDeleteBtn: {
      type: Boolean,
      default: true,
    },
    showAddDocumentBtn: {
      type: Boolean,
      default: true,
    },
    documents: {
      type: Array,
      required: true,
    },
    errorMessages: {
      type: Array,
    },
    typeDocument: {
      type: String,
      required: true,
    },
    acceptFile: {
      type: Array,
      default: () => [...acceptFileDefault],
    },
  },
  data: () => ({
    InputType,
    mdiTrashCanOutline,
    getSubDescription,
    getValidationErrorText,
    AdditionalDocumentsType,
    getFileLink,
    error: '',
    dialog: false,
    file: null,
    fileSig: null,
    isSigningPlugin: false,
    loading: false,
    loadingSign: false,
    loadingRemove: false,
    documentFilds: cloneDeep(documentModel),
    documentPaymentFilds: cloneDeep(documentPaymentModel),
  }),
  validations() {
    const vAddDocument = {
      required: requiredIf(
        () => this.typeDocument === AdditionalDocumentsType.ADD_DOCUMENTS
      ),
      name: {
        required,
        EMOJI,
        maxLength: maxLength(1000),
      },
      date: {
        DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
      },
      issuer: {
        EMOJI,
        maxLength: maxLength(1000),
      },
      series: {
        EMOJI,
        maxLength: maxLength(25),
      },
      number: {
        EMOJI,
        maxLength: maxLength(50),
      },
    };

    const vAddDocumentPayment = {
      required: requiredIf(
        () => this.typeDocument === AdditionalDocumentsType.ADD_QUITTANCES
      ),
      name: {
        required,
        EMOJI,
        maxLength: maxLength(1000),
      },
      date: {
        DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
      },
      number: {
        EMOJI,
        maxLength: maxLength(50),
      },
      payerLastname: {
        required,
        EMOJI,
        PERSON_NAME,
        maxLength: maxLength(60),
      },
      payerFirstname: {
        required,
        EMOJI,
        PERSON_NAME,
        maxLength: maxLength(60),
      },
      payerMiddleName: {
        EMOJI,
        PERSON_NAME,
        maxLength: maxLength(60),
      },
      amount: {
        required,
        CURRENCY_MAX_LENGTH,
        CURRENCY_ONLY_POSITIVE,
      },
      accountNum: {
        required,
        EMOJI,
        minLength: minLength(20),
      },
      accountCorrNum: {
        EMOJI,
        minLength: minLength(20),
      },
      bankName: {
        required,
        EMOJI,
        maxLength: maxLength(255),
      },
      bik: {
        required,
        minLength: minLength(9),
      },
    };

    return {
      documentFilds: vAddDocument,
      documentPaymentFilds: vAddDocumentPayment,
      file: {
        required,
        FILE_TYPE: FILE_TYPE(this.acceptFile),
        FILE_SIZE: FILE_SIZE(25),
        FILE_NAME_MAX_LENGTH: FILE_NAME_MAX_LENGTH(100),
      },
      fileSig: {
        required,
        FILE_TYPE: FILE_TYPE(['sig']),
        FILE_SIZE: FILE_SIZE(25),
        FILE_NAME_MAX_LENGTH: FILE_NAME_MAX_LENGTH(100),
        FILE_SIG_NAME: FILE_SIG_NAME(this.file),
      },
    };
  },
  methods: {
    reset(inputType) {
      if (inputType === InputType.FILE) this.file = null;

      if (!inputType) {
        this.documentFilds = { ...documentModel };
        this.documentPaymentFilds = { ...documentPaymentModel };
        this.file = null;
      }

      this.$v.$reset();
      this.fileSig = null;
      this.isSigningPlugin = false;
    },

    async upload() {
      ErrorAlertModule.setErrorAlert('');
      this.error = '';

      this.$v[documentTypeFilds[this.typeDocument]].$touch();
      this.$v.file.$touch();
      this.$v.fileSig.$touch();

      if (
        this.$v[documentTypeFilds[this.typeDocument]].$invalid === false &&
        this.$v.file.$invalid === false &&
        this.$v.fileSig.$invalid === false
      ) {
        const fields = cloneDeep(this[documentTypeFilds[this.typeDocument]]);
        const documents = cloneDeep(this.documents);

        this.loading = true;

        try {
          if (this.isSigningPlugin) {
            const file = await saveFile(this.file);
            const fileSig = await saveSigFile({
              sigBas64: this.fileSig.sigBas64,
              fileName: this.fileSig.fileName,
            });
            const document = deepmerge(fields, {
              file,
              fileSig,
            });

            this.$emit('change', [...documents, document]);
            this.dialogCloseHandler();

            return;
          }

          const { file, signFile, message, status } = await checkSign(
            this.file,
            this.fileSig
          );

          if (status === 'OK') {
            const document = deepmerge(fields, {
              file,
              fileSig: signFile,
            });

            this.$emit('change', [...documents, document]);
            this.dialogCloseHandler();

            return;
          }

          this.error = message;

          this.loading = false;
        } catch (error) {
          errorHandler(error);

          this.dialogCloseHandler();

          await this.$vuetify.goTo('#header-target', { duration: 200 });
        }
      }
    },

    dialogCloseHandler() {
      this.loading = false;
      this.dialog = false;
      this.reset();
    },

    async remove(fileSigLink) {
      this.loadingRemove = true;
      ErrorAlertModule.setErrorAlert('');

      try {
        await deleteFile(fileSigLink);

        const deletedIndex = this.documents.findIndex(
          (document) => document.fileSig.link === fileSigLink
        );

        const documents = cloneDeep(this.documents);
        documents.splice(deletedIndex, 1);

        this.$emit('change', documents);
      } catch (error) {
        errorHandler(error);
      }

      this.loadingRemove = false;
    },

    signFile() {
      // Создать саму подпись
      const file = this.file;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        this.loadingSign = true;

        let header = ';base64,';
        let fileData = reader.result;
        let fileContent = fileData.substr(
          fileData.indexOf(header) + header.length
        );
        try {
          const signs = await ServicesModule.runSign({
            sigBas64: fileContent,
          });
          this.isSigningPlugin = true;
          this.fileSig = {
            sigBas64: signs.sigBas64[0],
            fileName: file.name,
            name: `${file.name}.sig`,
          };
        } catch {
          await this.$vuetify.goTo('#header-target', { duration: 200 });
        }

        this.loadingSign = false;
      };
    },
  },
};
</script>

<style scoped lang="scss">
.no-value {
  padding: 15px;
  text-align: center;
}

.ud-error {
  padding-top: 8px;
  padding-bottom: 16px;
}

.ud-error__text {
  font-size: 12px;
  line-height: 1;
  color: $color-error;
}

.ud-error__wrapper {
  min-height: 12px;
}

.form {
  padding: 24px;
  background-color: #ffffff;
}
</style>
